import { CommonFileData } from "../data/common-file-data";
import { HttpHeaders, HttpParams, HttpClient } from "@angular/common/http";

/**
 * ファイルに関するユーティリティクラスです。
 */
export class FileUtil {
  // ファイルダウンロード
  public static fileDownload(http: HttpClient, fileName: string, deleteFlg: string = "", downloadFileName: string) { // ST-361
    let fileData = new CommonFileData();
    fileData.fileName = fileName;
    if (deleteFlg === "") {
      fileData.delete = true;
    } else {
      fileData.delete = false;
    }
    
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set('Single-Access', 'true');
    let params: HttpParams = new HttpParams();
    http.post('/FileDownload', fileData, { headers: headers, params: params, responseType: 'blob', observe: 'response' }).subscribe(result => {
      const file = new Blob([result.body], { type: 'application/octet-stream' });
      if ('msSaveOrOpenBlob' in navigator) { // IEの場合
        window.navigator.msSaveOrOpenBlob(file, downloadFileName); // ST-361
      } else { // IE以外の場合
        const link = document.createElement('a');
        link.setAttribute('href', window.URL.createObjectURL(file));
        link.setAttribute('download', downloadFileName); // ST-361
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }
  // ファイルオープン(PDF以外の場合、プラグインがインストール必要)
  public static fileOpen(http: HttpClient, fileName: string) {
    let fileData = new CommonFileData();
    fileData.fileName = fileName;
    fileData.delete = false;
    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set('Single-Access', 'true');
    let params: HttpParams = new HttpParams();
    http.post('/FileDownload', fileData, { headers: headers, params: params, responseType: 'blob', observe: 'response' }).subscribe(result => {
      const file = new Blob([result.body], { type: 'application/' + fileName.substring(fileName.lastIndexOf('.') + 1) });
      window.open(window.URL.createObjectURL(file));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/utility/file-util.ts